import jss from 'jss';

const styles = {
  outerContainer: {
    minHeight: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'stretch',
    height: '100%',
    width: '100%',
    maxWidth: 'calc(100vw - 250px)',
    flex: 1
  },
  tableContainer: {
    flex: 1,
    maxWidth: 'calc(100vw - 550px)',
    position: 'relative',
    overflow: 'scroll'
  },
  table: {
    width: 'calc(100vw - 550px)',
    display: 'block',
    position: 'absolute',
    top: 0,
    left: 0,
  },
  modifyContainer: {
    width: 300,
    borderLeft: '2px solid #dee2e6',
    padding: '30px 15px',
    backgroundColor: '#ededed'
  },
  headerContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    padding: '15px 15px 15px 10px'
  },
  actionsContainer: {
    '& > *': {
      marginLeft: 5
    }
  }
};

export const { classes } = jss.createStyleSheet(styles).attach();



// WEBPACK FOOTER //
// ./src/views/user/styles/modify-table.js